class ThemeDrawer extends HTMLElement {
  open() {
    this.setAttribute('open', '');
    this.style.display = 'block';
    const overlay = this.querySelector('.theme-drawer__overlay');
    if (overlay) overlay.style.display = 'block';
    document.body.classList.add('drawer-open');
  }

  close() {
    this.removeAttribute('open');
    this.style.display = 'none';
    const overlay = this.querySelector('.theme-drawer__overlay');
    if (overlay) overlay.style.display = 'none';
    document.body.classList.remove('drawer-open');
  }

  handleEscKey = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  connectedCallback() {
    if (!this.hasAttribute('open')) {
      this.style.display = 'none';
      const overlay = this.querySelector('.theme-drawer__overlay');
      if (overlay) overlay.style.display = 'none';
    }
    // Listener para cerrar al hacer click en overlay
    const overlay = this.querySelector('.theme-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }
    // Listener para cerrar con Esc
    document.addEventListener('keydown', this.handleEscKey);
  }

  disconnectedCallback() {
    // Cleanup listeners
    const overlay = this.querySelector('.theme-drawer__overlay');
    if (overlay) {
      overlay.removeEventListener('click', () => this.close());
    }
    document.removeEventListener('keydown', this.handleEscKey);
  }
}

customElements.define('theme-drawer', ThemeDrawer);